<div class="listview container-fluid">
  <base-customer-provider-list-filters
    [locations]="locations"
    [filterValues]="filterValues"
  ></base-customer-provider-list-filters>
  <div class="listview-header">
    <div class="row">
      <div
        class="col"
        baseTruncate
      >
        {{ 'location.singular' | translate }}
      </div>
      <div
        class="col"
        baseTruncate
      >
        {{ 'branch.linked' | translate }} | {{ 'provider' | translate }}
      </div>
      <div
        class="col-1"
        baseTruncate
      >
        {{ 'deliveryPriority' | translate }}
      </div>

      <div
        class="col"
        baseTruncate
      >
        {{ 'address' | translate }}
      </div>
      <div
        class="col-2"
        baseTruncate
      >
        <img
          src="assets-global/images/izs/izs-logo-multicolor.svg"
          alt="izs-logo"
          class="me-1"
        />
        {{ 'izs.rating' | translate }}
      </div>
    </div>
  </div>

  <div
    class="listview-item"
    *ngFor="let item of providers"
    (click)="openProviderDetailModal(item)"
  >
    <base-customer-provider-list-item
      [provider]="item"
      (openIZSInfo)="openIZSInfoModal($event)"
    ></base-customer-provider-list-item>
  </div>

  <base-empty-list-row
    *ngIf="!providers?.length"
    message="providers.emptyList"
  ></base-empty-list-row>

  <div class="pagination">
    <base-pagination
      [page]="page"
      [itemsCount]="itemsCount"
      [size]="size"
    ></base-pagination>
  </div>
</div>

<ng-template #providerDetailsTemplate>
  <base-customer-provider-details-modal
    [provider]="selectedProvider"
    [detailsModalRef]="detailsModalRef"
    [isIZSTab]="isIZSInfoTab"
  ></base-customer-provider-details-modal>
</ng-template>
